import posthog from 'posthog-js';

posthog.init('phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only', 
});

export default posthog;